import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  // Device Log
  getDeviceLogs(config) {
    return axiosInstance.get('/master/device_log', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getLogInformation(param) {
    return axiosInstance.get(`/master/device_log?findField=${param.findField}&findValue=${param.findValue}&page=${param.page}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  getLogInformationByDate(param) {
    return axiosInstance.get(`/master/device_log?findField=${param.findField}&findValue=${param.findValue}&page=${param.page}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  addDeviceLog(data) {
    return axiosInstance.post('/master/device_log', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  updateDeviceLog(data, id) {
    return axiosInstance.put(`/master/device_log/${id}`, data, {
      cancelToken: getNewCancelToken(),
    });
  },
  deleteLogDevice(id) {
    return axiosInstance.delete(`/master/device_log/${id}`, {
      cancelToken: getNewCancelToken(),
    });
  },

  // Device
  getDevices(config) {
    return axiosInstance.get('/master/device', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getDevicesByAssetId(param) {
    return axiosInstance.get(`/master/device?findField=${param.findField}&findValue=${param.findValue}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  getDeviceByMassId(massId) {
    return axiosInstance.get(`/master/device?findField=devcMassId&findValue=${massId}&limit=100`, {
      cancelToken: getNewCancelToken(),
    });
  },
  addDevice(data) {
    return axiosInstance.post('/master/device', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  updateDevice(data, id) {
    return axiosInstance.put(`/master/device/${id}`, data, {
      cancelToken: getNewCancelToken(),
    });
  },
  deleteDevice(id) {
    return axiosInstance.delete(`/master/device/${id}`, {
      cancelToken: getNewCancelToken(),
    });
  },

  // Series
  getSeriesDeviceWeekly(config) {
    return axiosInstance.get('/series/base/last/1/week', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getSeriesDevicesWeekly(devices) {
    const config = {
      filter: {
        device: devices,
      },
      cancelToken: getNewCancelToken(),
    };
    return axiosInstance.get('/series/base/last/1/week', config);
  },
};
